export default {
  'notFound.title': 'Not Found',
  'notFound.description': 'Oops, this page was not found :(',
  'notFound.button': 'Back to home',
};
